import { render, staticRenderFns } from "./BubbleMenuTable.vue?vue&type=template&id=6bad82c3&"
import script from "./BubbleMenuTable.vue?vue&type=script&lang=js&"
export * from "./BubbleMenuTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports